import { useState, useEffect } from "react";

export const useIsShortHeight = (heightThreshold = 600): boolean => {
  const [isShortHeight, setIsShortHeight] = useState(false);

  useEffect(() => {
    const checkHeight = () => {
      setIsShortHeight(window.innerHeight < heightThreshold);
    };

    checkHeight();

    window.addEventListener("resize", checkHeight);

    return () => window.removeEventListener("resize", checkHeight);
  }, [heightThreshold]);

  return isShortHeight;
};
